import { type ComponentPropsWithRef } from "react"

import { cn } from "@/shared/lib/utils"

type ModalContentProps = ComponentPropsWithRef<"div">

export const ModalContent = ({ children, className, style, ref, ...props }: ModalContentProps) => {
  return (
    <div
      {...props}
      ref={ref}
      className={cn("custom-scrollbar mt-2 flex-1 overflow-y-auto px-1", className)}
      style={{ cursor: "default", ...style }}>
      {children}
    </div>
  )
}

ModalContent.displayName = "ModalContent"

export default ModalContent
